import type { AxiosResponse } from "axios";
import { ApiInstance } from "@/api";

export default class AUTH_API {
  static async postLogin(
    email: string,
    password: string,
    username: string = "string",
  ): Promise<
    AxiosResponse<{
      accessToken: string;
      id: string;
      message: string;
    }>
  > {
    return ApiInstance.post<{
      accessToken: string;
      id: string;
      message: string;
    }>("/auth/login", {
      email,
      password,
      username,
    });
  }

  static async postRefresh(): Promise<
    AxiosResponse<{
      accessToken: string;
      id: string;
      message: string;
    }>
  > {
    return ApiInstance.post<{
      accessToken: string;
      id: string;
      message: string;
    }>("/auth/refreshToken");
  }

  static async logOut(): Promise<AxiosResponse> {
    return ApiInstance.delete("/auth");
  }
}
